import * as Sentry from '@sentry/vue'

/**
 * Observabilidad de la capa offline. Breadcrumbs + captura de errores a Sentry
 * (ya configurado en la app). Todo va con guard: si Sentry no está inicializado
 * (ej. dev local) degrada a console sin romper.
 */

// Imprimimos a consola para debug/testing. En el navegador siempre (en prod el
// build elimina los console.* vía drop_console). En tests (Node, sin window)
// queda silenciado para no ensuciar la salida.
// ISS-849: VERIFICADO que el build de prod garantiza drop_console
// (quasar.config.js → build.uglifyOptions.compress.drop_console: true), así que
// los console.* NO llegan a producción y el gate `typeof window` se deja como está.
const isLocal = () => typeof window !== 'undefined'

/** Migaja de contexto para el timeline de Sentry (queue depth, sync, conflictos). */
export const recordBreadcrumb = (category, message, level = 'info', data = {}) => {
  if (isLocal()) console.log(`[offline:${category}] ${message}`, data)
  try {
    Sentry.addBreadcrumb({ category, message, level, data })
  } catch {
    // Sentry no inicializado: no-op
  }
}

/** Captura un error de la capa offline, etiquetado para filtrar en Sentry. */
export const captureOfflineError = (error, context = {}) => {
  if (isLocal()) console.error('[offline:error]', error, context)
  try {
    Sentry.captureException(error, { tags: { area: 'offline' }, extra: context })
  } catch {
    console.error('[offline]', error, context)
  }
}
